import React, { useEffect, useMemo, useState } from "react";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import { DeleteEmptyParams } from "../helpers/Common";
import { TableOptions } from "../config/Table";

const useTable = (url: string, formData: Dati.TListaParametri) => {
    const [IsLoading, setIsLoading] = useState(false);
    const [Data, setData] = useState<any>(undefined);
    const [Params, setParams] = useState<Dati.CParamAPIPagine>({ Sessione: Glob.GetSessione().Sessione, Numero: 30, Pagina: 1 });
    const [SortParams, setSortParams] = useState<Dati.TListaParametri>({});

    useEffect(() => {
        GetData();
    }, [Params, SortParams]);

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: url,
            ParamURLClasse: Params,
            Metodo: "POST",
            OnRis: OnSearch,
            OnErrore: OnError,
            OnInvio: (sender: ChiamaWeb) => DeleteEmptyParams({ ...formData, ...SortParams })
        };
        setIsLoading(true);
        new ChiamaWeb().Chiama(Param);
    };

    const OnError = (sender: ChiamaWeb, errore: Error) => {
        setIsLoading(false);
    };

    const OnSearch = (sender: ChiamaWeb, dati: any) => {
        setData(dati);
        setIsLoading(false);
    };

    const OnSortChange = (changedColumn: string, direction: string): void => {
        setSortParams({ OrdinaCampo: changedColumn, OrdinaVerso: direction.toUpperCase() });
    };

    const OnChangeRowsPerPage = (numberOfRows: number): void => {
        setParams({ ...Params, Numero: numberOfRows, Pagina: 1 });
    };

    const OnChangePage = (currentPage: number): void => {
        setParams({ ...Params, Pagina: currentPage + 1 });
    };

    const OnRefresh = (): void => {
        OnChangePage(Params.Pagina - 1);
    };

    const Options = useMemo(
        () => ({
            ...TableOptions,
            textLabels: {
                body: {
                    noMatch: Trad.Trad("Nessun record corrisponde ai parametri di ricerca"),
                    toolTip: Trad.Trad("Ordina")
                },
                pagination: {
                    next: Trad.Trad("Next"),
                    previous: Trad.Trad("Previous"),
                    rowsPerPage: Trad.Trad("Rows per page"),
                    displayRows: Trad.Trad("of")
                }
            },
            page: Params.Pagina - 1,
            rowsPerPage: Params.Numero,
            onChangeRowsPerPage: OnChangeRowsPerPage,
            onColumnSortChange: OnSortChange,
            onChangePage: OnChangePage,
            onRefresh: OnRefresh,
            count: Data?.RigheTotali || 0,
            tableBodyMaxHeight: IsLoading ? "45vh" : "100%",
            pagination: true
        }),
        [Params, IsLoading, Data, Glob.GetLocale().Lingua]
    );

    return {
        Data,
        Options,
        IsLoading,
        GetData
    };
};

export default useTable;



// WEBPACK FOOTER //
// ./src/inar2/hooks/Table.ts